export const POEM = {
  lines: [
    "Walking through miles of hope,",
    "What do we see..",
    "Lingering sighs, deep uncertainties..",
    "Fountains of faith, stars, lamps lit across pavements and skies",
    "Eyes, like ours, meeting ours, looking for symphonies",
    "Melodies, catching our breath,",
    "Through wide long patches I often met myself",
    "Alongside and beside me",
    "Sensations, sensitivities",
    "Joys of the colored sun, skies I watched like bewildered dreams",
  ],
  byline: "Priyanka Jha",
};
